import { CatalogItem } from "./CatalogItem";
import { AllowedPrivacy } from "./Experience";

/**
 * This is a intermediate UI Base Model for Pricing.
 * This will be used by Product Pricing, Pricing Variations for schedules
 */
export interface PricingGroup {
    privacy: AllowedPrivacy;
    pricingType: PricingType;
    terms: PricingTerm[];
    pricingStructure?: PricingStructure;
}

/**
 * This is a intermediate UI Model for displaying and capturing values from Product Pricing.
 * PurchaseRules will be converted to Demographic Pricing Group and while saving we will convert this to PurchaseRules
 */
export interface DemographicPricingGroup extends PricingGroup {
    pricingStructure: PricingStructure;
    schedules: PricingGroupSchedules;
}

export interface PricingTerm {
    demographicPrices: DemographicPrice[];
    quantityMin?: number;
    quantityMax?: number;
    type: PricingTermType;
}

export interface DemographicPrice {
    actionId?: ID; // Action Id
    price?: number;
    template: { id: ID };
    catalogItem?: CatalogItem;
    adjustmentType?: AdjustmentType;
    adjustmentAmount?: number;
    adjustmentOperation?: AdjustmentOperation;
}

export enum AdjustmentType {
    ABSOLUTE = "absolute",
    PERCENT = "percent",
}

export enum AdjustmentOperation {
    MARKUP = "markup",
    MARKDOWN = "markdown",
    DISCOUNT = "discount",
    FINAL = "final",
}

export enum PricingStructure {
    FLAT = "flat",
    RELATIVE = "relative",
    TIERED = "tiered",
    BUYOUT = "buyout",
}

export interface PricingGroupSchedules {
    all: boolean;
    items: ID[];
}

export enum PricingType {
    PER_PERSON = "per_person",
    PER_OUTING = "per_outing",
}

export const PricingTypeCopy: { [key in PricingType]: string } = {
    [PricingType.PER_PERSON]: "Per person",
    [PricingType.PER_OUTING]: "Per event",
};

export enum PricingTermType {
    BASE = "base",
    ADJUSTMENT = "adjustment",
}
